import { connect } from 'react-redux';

import { concat, Dictionary, filter, head, map, partial, reverse, sortBy } from 'lodash';

import { PageUserSalary as Page, PageUserSalaryProps } from '../components/PageUserSalary/PageUserSalary';
import { IState, State } from '../models/State';
import { Api } from '../api/Api';
import { ActionEntity } from '../reducers/ActionsEntity';
import { Schema } from '../models/Schema';
import { Course } from 'salary-shared';
import { DispatchFunc } from '../utils/redux';
import { currentMonth, meId, month } from '../utils/utils';

const pForMonth = (month: string, o: { date: string }) => o.date === month;

const courseForDate = (courses: Dictionary<Course>, date: string) => {
	let result: any = filter(courses, s => s!._id <= date);
	result = sortBy(result, '_id');
	result = reverse(result);
	result = map(result, 'price');
	result = head(result);
	return result;
};

export const PageUserSalary = connect<{}, {}, PageUserSalaryProps, IState>(
	(state, ownProps) => {
		const userId = meId();
		const mon = month(ownProps.match.params.month);

		return {
			user: State.entity.users(state)[userId],
			showTitle: false,
			salary: head(filter(State.model.salaries.byUser(state)[userId], partial(pForMonth, mon))),
			dateCourse: courseForDate(State.entity.courses(state), mon),
		};
	},
	(dispatch: DispatchFunc, ownProps) => {
		const userId = meId();
		const mon = month(ownProps.match.params.month);

		const _salaries = () => {
			if (mon === currentMonth) {
				return Api.salaries.createForDate(mon);
			} else {
				return Api.salaries.forDate(mon);
			}
		};

		return {
			onInit: () => {
				return Promise.all([
					Api.users.find({
						_id: userId,
					}),
					_salaries(),
					Api.courses.forDate(mon),
				])
					.then(resps =>
						concat(
							ActionEntity.loadResp(Schema.users!)(resps[0]),
							ActionEntity.loadResp(Schema.salaries!)(resps[1]),
							ActionEntity.loadResp(Schema.courses!)(resps[2]),
						),
					)
					.then(dispatch);
			},
		};
	},
)(Page);
